import { find, propEq } from "ramda";

export const getActivityByIdSelector = (state, activityId) => {
  if (!state.recentActivity.data) {
    return undefined;
  }
  return find(propEq("event_id", activityId), state.recentActivity.data);
};
